import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowLeftIcon, ListIcon, UserCircleIcon, XIcon } from "@phosphor-icons/react";
import { customerApi, hasCustomerToken } from "@/lib/customerApi";

const links = (email) => [
  { to: "/", label: "Home", id: "hub", cls: "hidden lg:flex", icon: true },
  { to: "/mt5#bots", label: "Bots", id: "bots", cls: "hidden md:inline" },
  { to: "/pricing", label: "Pricing", id: "pricing", cls: "hidden md:inline" },
  { to: "/track-record", label: "Track record", id: "track", cls: "hidden md:inline" },
  { to: email ? "/account/setup" : "/setup", label: "Setup guide", id: "setup", cls: "hidden md:inline" },
  { to: "/legal", label: "Risk & terms", id: "legal", cls: "hidden" },
];

export default function StoreTopbar({ subtitle = "MT5 Expert Advisors" }) {
  const [email, setEmail] = useState(null);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  useEffect(() => {
    if (!hasCustomerToken()) return;
    customerApi.get("/store/account/me").then((r) => setEmail(r.data.email)).catch(() => {});
  }, []);
  useEffect(() => setOpen(false), [pathname]);
  const items = links(email);
  return (
    <header className="sticky top-0 z-40 border-b border-blue-900/40 backdrop-blur-md bg-[#050914]/90">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between gap-3">
        <Link to="/mt5" className="flex items-center gap-3 min-w-0" data-testid="store-topbar-logo">
          <img src="/botgenomix-logo-512.png" alt="BotGenomix" className="h-9 w-9 sm:h-10 sm:w-10 rounded-lg" />
          <div className="min-w-0">
            <div className="text-lg font-medium tracking-tight">
              Bot<span className="text-[#FBBF24]">Genomix</span>
              <span className="hidden sm:inline ml-2 text-[#38BDF8] mono text-xs uppercase tracking-widest">MT5</span>
            </div>
            <div className="hidden sm:block mono text-[9px] uppercase tracking-[0.3em] text-[#64748B]">{subtitle}</div>
          </div>
        </Link>
        <nav className="flex items-center gap-1 sm:gap-2 mono text-[10px] uppercase tracking-widest">
          {items.map((l) => (
            <Link key={l.id} to={l.to} data-testid={`store-topbar-${l.id}`} className={`${l.cls} items-center gap-1 px-3 py-2 text-[#94A3B8] hover:text-white`}>
              {l.icon && <ArrowLeftIcon size={12} />} {l.label}
            </Link>
          ))}
          <Link
            to={email ? "/account" : "/account/login"}
            data-testid="store-topbar-account"
            className="flex items-center gap-1.5 px-3 sm:px-4 py-2 rounded-full whitespace-nowrap border border-[#FBBF24]/50 bg-[#FBBF24]/10 text-[#FBBF24] hover:bg-[#FBBF24]/20 transition-colors"
          >
            <UserCircleIcon size={14} weight="fill" /> {email ? "Account" : "Log in"}
          </Link>
          <button onClick={() => setOpen((o) => !o)} aria-label="Menu" aria-expanded={open} data-testid="store-topbar-menu"
            className="md:hidden ml-1 p-2 rounded-lg border border-blue-900/60 text-[#E2E8F0]">
            {open ? <XIcon size={18} /> : <ListIcon size={18} />}
          </button>
        </nav>
      </div>
      {open && (
        <div data-testid="store-topbar-mobile-menu" className="md:hidden border-t border-blue-900/40 bg-[#050914] px-4 pb-4">
          {items.map((l) => (
            <Link key={l.id} to={l.to} onClick={() => setOpen(false)} data-testid={`store-mobile-${l.id}`}
              className={`block py-3.5 border-b border-blue-900/30 text-base ${pathname === l.to.split("#")[0] ? "text-[#FBBF24]" : "text-[#E2E8F0]"}`}>
              {l.label}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
}
